import React, { useContext, useState, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import '../styles/Head.css';
import PageFooter from './PageFooter.js';
import PageHeader from './PageHeader.js';
import { GlobalStateContext } from './GlobalStateContext.js';
import GlobalSettings from './GlobalSettings.js';
import DOMPurify from 'dompurify';

const Home = () => {
    const {
        surveyCode,
        setSurveyCode,
        questionset_id,
        setQuestionsetId,
        participation,
        setParticipation, 
        participationCode,
        setParticipationCode,
        surveyId,
        setSurveyId,
        debugMode,
        setDebugMode,
        participationCodeString,
        setParticipationCodeString, 
        token,
        setToken,
        previewMode,
        setPreviewMode,
        debugSaveMode,
        setDebugSaveMode,
        surveyMode,
        setSurveyMode,
    } = useContext(GlobalStateContext);
    

    const [localSurveyCode, setLocalSurveyCode] = useState("");
    const [surveyName, setSurveyName] = useState([]);
    const [tokenValid, setTokenValid] = useState("false");
    const [tokenMessage, setTokenMessage] = useState('');
    const [welcome, setWelcome] = useState([]);
    const [bodytext, setBodytext] = useState([]);
    const [bodytext2, setBodytext2] = useState([]);
    const [btnText, setBtnText] = useState([]);
    const [check, setCheck] = useState(false);
    const [showCheck, setShowCheck] = useState(false);
    const [surveyState, setSurveyState] = useState(0);
    const [isFirstLoad, setIsFirstload] = useState(true);
    const [participationInfo, setParticipationInfo] = useState('');
    const [activityInfo, setActivityInfo] = useState('');
    const navigate = useNavigate();

    // Verwende useEffect, um die asynchronen Funktionen auszuführen
    useEffect(() => {
        const performTasks = async () => {
            try {
                await resetValues();
                await handleUrlParameters();
                // console.log("SurID", surveyId);
                
                await Promise.all([
                    fetchWelcomeText(),
                    fetchSurveyText(),
                    fetchHomeText(),
                    fetchBtnText()
                ]);
                
            } catch (error) {
                console.error('Ein Fehler ist aufgetreten:', error);
            }
        };
    
        performTasks();
    }, [isFirstLoad]);
    
    

    const resetValues = async () => {
        if (isFirstLoad === true) {
            localStorage.clear();
            if(GlobalSettings.debugMode==='on') 
                console.log("Storage cleared");
            setIsFirstload(false);
            setSurveyMode('');
        }
    };

    const handleUrlParameters = async() => {
        setDebugMode(false);
        setPreviewMode(false);
        setSurveyMode('');
        setDebugSaveMode(false);
        setSurveyId(null);
        setParticipation(null);
        setSurveyState(null);
        
        const params = new URLSearchParams(window.location.search);
        const participationCodeString = params.get('participationCode');
        
        if(participationCodeString) {
            let participationCheck = 1;
            //console.log("PM", previewMode, 'DM', debugMode, "PCS", participationCodeString);
            if(participationCodeString){
                //console.log("Check");
                const result = await fetch(`/api/participationCheck/${participationCodeString}`)
                    .then(response => response.json())
                    .catch(console.log);
                    
                setParticipation(result.checkparticipation);
                setParticipationCode(encodeURIComponent(participationCodeString));
                setSurveyId(result.survey_id);
                setCheck(true);
                
               /* if(surveyId > 0){
                const result = await fetch(`/api/checkSurveyActive/${surveyId}`)
                    .then(response => response.json())
                    .catch(console.log);
                    setSurveyState(result);
                    console.log(result);
                    
                }*/
                return;
            }
        }
        
        const debug = params.get('debug');
        if(GlobalSettings.debugMode === 'on') {    
            
            setDebugMode(debug !== '' && debug === 'DEBUGGING');
            if(debug !== '' && debug === 'DEBUGGING')
                setSurveyMode('debug');
            
        }

        const preview = params.get('preview');

        if(GlobalSettings.previewMode === 'on') {
            setPreviewMode(preview !== '' && preview === 'PREVIEW');
            if(preview !== '' && preview === 'PREVIEW')
                setSurveyMode('preview');
         }
        // console.log("SurveyMode", surveyMode);
        const survey = params.get('surveyId');
        if (survey !== '') {
            // check for ID
            const result = await fetch(`/api/checkPreviewSurvey/${survey}`)
                    .then(response => response.json())
                    .catch(console.log);
                    console.log(result);
            if (result > 0){
                setSurveyId(survey);
                localStorage.setItem('SurveyId', survey);
                setParticipation(-1);
        setSurveyState(0);
            }
            else {
                console.log("id stimmt nicht... aber so gar nicht");
                setParticipation(-3);
            }
        }
        else{ 
            setSurveyId(GlobalSettings.debugModeDefaultSurvey); 
        }
        
        //await surveyActivity(surveyState); // Aktivitätsinformation wird hier gesetzt
        /* if(localStorage.surveyId !== surveyId){
            localStorage.setItem('isFirstload','true');
        } */

            

        const debugSave = params.get('debugModeWithSaving');
        setDebugSaveMode(debugSave!=='' && debugSave === 'yes');
        //checkSurveyMode();
        //console.log("pcs", participationCodeString, "dbug", debug, debugMode, "pv", preview, previewMode, "survey", survey, surveyId, "dbugSav", debugSave);
        //console.log("DM",debugState,  debugMode, "pState", previewState, "PM", previewMode);
    }

    const getSurveyActivity = async (surveyId) => {
        try {
          const response = await fetch(`/api/checkSurveyActive/${surveyId}`);
          if (!response.ok) {
            throw new Error(`Error: ${response.statusText}`);
          }
          const result = await response.json();
          setSurveyState(result);
        } catch (error) {
          console.error('Failed to fetch survey activity:', error);
        }
      };

    useEffect(() => {
        if (surveyId !== null){
        getSurveyActivity(surveyId); // if participation changes, participationInfo will be set
        }
    }, [surveyId]);

  
    const getParticipationInfo = async (participation) => {
        let info = '';
        if(GlobalSettings.debugMode==='on') 
            console.log("SurveyMode", surveyMode, "participation", participation, "Debbug", debugMode, "preview", previewMode);
        if (participation < 2 && surveyMode.length === 0) {
            
            switch (participation) {
                case -2:
                    info = '<p>Teilnahmecode nicht vorhanden, bitte klicken Sie den Link in der Benachrichtigungsmail an.</p>';
                    break;
                case -1:
                    info = '<p>Der Teilnahmecode fehlt. Bitte nutzen Sie den Link aus der Mail.</p>';
                    break;
                case 0:
                    info = '';
                    break;
                case 1:
                    info = '<p>Sie haben an dieser Umfrage bereits erfolgreich teilgenommen.</p>';
                    break;
                default:
                    info = '';
            }
        } else {
            info = '<p>Das ist eine Umfrage-Vorschau, bitte direkt auf "Zur Befragung" klicken.</p>';
            if(participation === -3) {
                info = info + "Die Umfrage-ID ist nicht vorhanden, bitte versuchen Sie es später noch einmal. "
            }

        }
        setParticipationInfo(info);
    };  

    useEffect(() => {
        if (participation !== null){
        getParticipationInfo(participation); // if participation changes, participationInfo will be set
        }
    }, [participation]);

    const surveyActivity = async (surveyState) => {
        let info = '';
        if(GlobalSettings.debugMode==='on') 
            console.log("surveyActivity", surveyState, "surveyMode", surveyMode);
        if(surveyMode.length===0){
            switch (surveyState) {
                case GlobalSettings.stateDraft:
                    info = '<p>Die Umfrage steht noch nicht bereit, probieren Sie es bitte zum angegebenen Start-Termin erneut.</p>';
                    break;
                case GlobalSettings.stateActive:
                case GlobalSettings.stateProgress:
                    info = '';
                    break;
                case GlobalSettings.stateBreak:
                    info = '<p>Die Beantwortung der Umfrage ist zur Zeit pausiert.</p>';
                    break;
                case GlobalSettings.stateEnded:
                case GlobalSettings.stateTerminated:
                case GlobalSettings.stateSupplied:
                    info = '<p>Der Zeitraum zur Teilnahme an der Umfrage ist abgelaufen. Wir werten derzeit die Ergebnisse aus.</p>';
                    break;
                default: 
                    info = '<p>Der Teilnahmecode ist nicht mit einer Umfrage verknüpft.</p>'; 
            }
        } else {
            info = '<p>Sie führen diese Umfrage im ' + (surveyMode === 'preview' ? "Vorschau" : "Debug") + ' - Modus durch.</p>';
        }
        setActivityInfo(info); // Speichern des Ergebnisses im Zustand
    };

    useEffect(() => {
        if(surveyState != null){
        surveyActivity(surveyState); // Diese Funktion wird nur ausgeführt, wenn SurveyState sich ändert
        }
    }, [surveyState]);

    const fetchWelcomeText = async () => {
        const result = await fetch(`/api/welcomeText/${GlobalSettings.languageId}`)
            .then(response => response.json())
            .catch(console.log);
        setWelcome(result);
    };

    const fetchSurveyText = async () => {
        const result = await fetch(`/api/surveyText/${GlobalSettings.languageId}`)
            .then(response => response.json())
            .catch(console.log);
        setBodytext2(result);
    };

    const fetchHomeText = async () => {
        const result = await fetch(`/api/Hometext/${GlobalSettings.languageId}`)
            .then(response => response.json())
            .catch(console.log);
        setBodytext(result);
    };

    const fetchBtnText = async () => {
        const result = await fetch(`/api/btntext/${GlobalSettings.languageId}`)
            .then(response => response.json())
            .catch(console.log);
        setBtnText(result);
    };

    useEffect(() => {
        checkToken(localSurveyCode);
      }, [localSurveyCode]);

    

    const checkToken = async () => {
        //  const introTextResult = await fetch(`/api/introClosedQuestions/${questionset_id}/${languageId}`);
        // console.log("surveyId", surveyId);
        const valid = await fetch(`/api/tokenCheck/${localSurveyCode}/${surveyId}`)
            .then(response => response.json())
            .catch(console.log);
        if(GlobalSettings.debugMode==='on') 
            console.log("Valid", valid);
        setTokenValid(valid);
        setShowCheck(true);
        if (valid === 'true') {
            setCheck(true);
            setTokenMessage('');
            setSurveyCode(localSurveyCode);
            setQuestionsetId(localSurveyCode); 
            setToken('true');
            localStorage.setItem('token', valid);
            const result = await fetch('/api/surveyName/' + localSurveyCode)
                .then(response => response.json())
                .catch(console.log);
            setSurveyName(result);
        }
        else {
            if(localSurveyCode.length>2)
            setTokenMessage('Der Survey-Code ist nicht korrekt.');
        }
    }

    const cleanParticipationInfo = DOMPurify.sanitize(participationInfo);
    const cleanActivityInfo = DOMPurify.sanitize(activityInfo);

    return (
        <div>
            <div>
                <PageHeader headerText="" surveyName={welcome[0]?.text} mode={surveyMode} />
            </div>
            <div className="questionBody">
                <div className="bubbleInactive"></div>
                <div className="bubbleActive">
                    <div className="bubbleTextContent">
                        {cleanParticipationInfo.length === 0 && cleanActivityInfo.length === 0 &&  (
                            <div>{bodytext[0]?.text}</div>
                        )}
                        <div dangerouslySetInnerHTML={{ __html: cleanParticipationInfo }} />
                        <div dangerouslySetInnerHTML={{ __html: cleanActivityInfo }} />
                        {cleanParticipationInfo.length === 0 && (
                            <div className="bubbleCode">
                                {cleanParticipationInfo.length === 0 && cleanActivityInfo.length === 0 ? (
                                    <>
                                    <label>
                                        {bodytext2[0]?.text}:
                                        <input
                                            type="text"
                                            className="bubbleCodeField"
                                            value={localSurveyCode}
                                            onChange={e => {
                                                setLocalSurveyCode(e.target.value);
                                              }}
                                            data-value={tokenValid}
                                        />
                                    </label>
                                   <p>{tokenMessage}</p>
                                    </>
                                ) : null}
                            </div>
                        )}
                    </div>
                    <div className="bubbleFooter">
                        <div className="bubbleStart">
                            {((tokenValid === 'true' && participation === 0 && surveyState === 3) || ((previewMode || debugMode) && participation !== -3)) && (
                                <Link to="/survey">
                                    <button className="btnToSurvey">{btnText[0]?.text}</button>
                                </Link>
                            )}
                        </div>
                    </div>
                </div>
                <div className="bubbleInactive"></div>
            </div>
            <PageFooter progress={100} />
        </div>
    );
}

export default Home;
